import { getLibelleData, changeBackgroundColorEvery, changeText } from './libelle-functions';

export const changeLibelle = () => {
  const libelleData = getLibelleData();

  let $libelle = $('#top-message-bar');

  // Until the libelle is loaded, in case of the funnle, make the changes and add event listeners for analytics.
  // By setting an interval we check every tenth of a second if it exists and until then clear the interval.
  const untilLibelleExists = setInterval(() => {
    if ($libelle.length > 0) {
      changeBackgroundColorEvery(4000, 5, $libelle, libelleData.color1, libelleData.color2);
      changeText($libelle.find('.text'), libelleData.texto, libelleData.textoMovil);
      clearInterval(untilLibelleExists);

      // Analytics
      if (typeof cube.analytics !== 'undefined') {
        listenerLibelle();
        listenerClosePopup();
        listenerMoreInfoPopup();
      }
    }
    $libelle = $('#top-message-bar');
  }, 1);

  // If it doesn't find the libelle clear the setInterval() after 2 seconds.
  setTimeout(() => {
    clearInterval(untilLibelleExists);
  }, 2000);
};

function listenerLibelle() {
  $('#top-message-bar').click(() => {
    cube.analytics.sendEvent(this, 'NavigationEvent', 'banners', 'envio_gratis', '', '');
  });
}

function listenerClosePopup() {
  $('.es-modalv2-container-delivery-black-friday .close').click(() => {
    cube.analytics.sendEvent(this, 'NavigationEvent', 'banners', 'envio_gratis', 'cerrar', '');
  });
}

function listenerMoreInfoPopup() {
  $('.text-delivery-black-friday .text-link').click(() => {
    cube.analytics.sendEvent(this, 'NavigationEvent', 'banners', 'envio_gratis', 'mas_info', '');
  });
}



// WEBPACK FOOTER //
// ./src/_override/shared/libelle/libelle.js